import { render, staticRenderFns } from "./TermsGame.vue?vue&type=template&id=64b42f4e&scoped=true"
import script from "./TermsGame.vue?vue&type=script&lang=js"
export * from "./TermsGame.vue?vue&type=script&lang=js"
import style0 from "./TermsGame.vue?vue&type=style&index=0&id=64b42f4e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b42f4e",
  null
  
)

export default component.exports